import { useQuery } from '@tanstack/react-query';
import { fetch_order_list } from './api';
import type { AdminOrderFilters } from './types';

export function use_order_list(filters: AdminOrderFilters) {
  return useQuery({
    queryKey: ['admin-order-list', filters],
    queryFn: () => fetch_order_list(filters),
    placeholderData: (prev) => prev,
  });
}
